var helpieUtils = require('../../helpie-util.js');
var tinymceService = require('./tinymce-service.js');
var addTermField = require('../../elements/add-term-field.js');

var Editor = {

    nonce: helpieKBFrontEndNonce,

    init: function() {
        var thisModule = this;

        // Initialise tinymce
        var titleSelector = '.helpie-article-editor .content-area .title.tinymce';
        var contentSelector = '.helpie-article-editor .content-area .editor-content.tinymce';

        tinymceService.init(titleSelector, 'inlineBasic');
        tinymceService.init(contentSelector, 'inlineFull');

        // Initialise addTermField
        addTermField.init('.article-terms-field');

        // Initialise semantic components for the controls section
        jQuery('.ui.accordion').accordion();
        jQuery('.ui.dropdown').dropdown();

        // Initialise eventshandler
        thisModule.eventsHandler();

        // Load Values when not in add-article mode
        if (!jQuery('.helpie-article-editor').hasClass('add-article')) {
            thisModule.loadPostValues();
        }
    },

    eventsHandler: function() {
        var thisModule = this;

        jQuery('.article-publish .publish').click(function() {
            thisModule.publishArticle();
        });

        jQuery('.article-publish .remove').click(function() {
            thisModule.deleteRevision();
        });

        jQuery('.article-publish .show-diff').click(function() {
            thisModule.setDiffMode();
        });

        jQuery('.article-publish .edit-post').click(function() {
            thisModule.setEditMode();
        });

        jQuery('.revisions .menu .item').click(function() {
            thisModule.setCurrentRevision(this);
        });

        jQuery('.add-category.input button').click(function() {
            thisModule.addCategory(this);
        });

        jQuery('.add-category input').bind("enterKey", function (e) {
            thisModule.addCategory(this);
        });

        jQuery('.add-category input').keyup(function (e) {
            if (e.keyCode == 13) {
                jQuery(this).trigger("enterKey");
                thisModule.emptyAddCategoryField();
            }
        });

        // console.log('window.innerWidth: ' + window.innerWidth);
        if (window.innerWidth <= 1024) {
            thisModule.mobileEvents();
            jQuery('.helpie-edit-page-container .controls-section .sticky').hide();
        } else{
            jQuery('.helpie-edit-page-container .controls-section .sticky').show();
        }

        jQuery( window ).resize(function() {
            thisModule.mobileEvents();
            if (window.innerWidth <= 1024) {

                jQuery('.helpie-edit-page-container .controls-section .sticky').hide();
            }else{
                jQuery('.helpie-edit-page-container .controls-section .sticky').show();
            }
        });


    },

    /* Various Event Handlers */

    mobileEvents: function(){
        jQuery(document).mouseup(function(e) {
            var container = jQuery('.helpie-edit-page-container .controls-section');
            var sticky = jQuery('.helpie-edit-page-container .controls-section .sticky');

            if (window.innerWidth <= 1024) {
            // if the target of the click isn't the container nor a descendant of the container
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    sticky.hide();

                }
            }
        });


        jQuery('.helpie-edit-page-container .mobile-controls').click(function(){
            jQuery('.helpie-edit-page-container .controls-section .sticky').toggle();
        });
    },

    addCategory: function() {
        console.log('addCategory: ');
        var new_category = jQuery('.add-category input').val();
        //get menu
        var $menu = jQuery('#helpdesk_category').find('.menu');
        //append new option to menu.
        // The 'new' data-value is used to tell php handler to create new category
        $menu.append('<div class="item" data-value="'+new_category+'">'+new_category+'</div>');
        //reinitialize drop down
        jQuery('.ui.dropdown#helpdesk_category').dropdown();

        //optional, set new value as selected option
        jQuery('.ui.dropdown#helpdesk_category').dropdown('set selected', [new_category]);

    },

    emptyAddCategoryField: function () {
        jQuery('.add-category input').click(function () {
            jQuery(this).remove();
        });
    },

    loadPostValues: function() {
        var thisModule = this;
        var post_id = jQuery('.helpie-article-editor').data('post-id');

        var nonce = helpieKBFrontEndNonce;
        var data = {
            'action': 'helpie_ajax_get_article_info',
            'nonce': nonce,
            'post_id': post_id
        };

        jQuery.post(my_ajax_object.ajax_url, data, function(response) {
            var ajaxResponse = JSON.parse(response);

            var post_title = ajaxResponse['post_title'];
            var post_content = ajaxResponse['post_content'];
            var category_id = ajaxResponse['category_id'];
            var tags_info = ajaxResponse['tags_info'];

            jQuery('.article-categories-field #helpdesk_category').dropdown('set selected', category_id);
            addTermField.renderTerms(tags_info);

        });

    },





    deleteRevision: function() {
        console.log('deleteRevision');
        var thisModule = this;
        var livePostProps = thisModule.getLivePostData();
        var revision_id = jQuery('.helpie-article-editor').data("revision-id");

        console.log('revision_id: ' + revision_id);

        var data = {
            'action': 'helpie_delete_revision',
            'nonce': thisModule.nonce,
            'revision_id': revision_id
        };


        jQuery.post(my_ajax_object.ajax_url, data, function(response) {
            console.log('response: ' + response);
        });
    },

    // Gets live Post data from the DOM as it is being edited
    getLivePostData: function() {
        var post_id = jQuery('.helpie-article-editor').data('post-id');
        var post_title = jQuery('.helpie-article-editor .content-area .title').html();


        if( jQuery('.wp-editor-container').length){
            // var post_content = tinymce.get('content-tinymce').getContent();

            var activeEditor = tinymce.get('content-tinymce');
            if(activeEditor == null || jQuery('#content-tinymce').attr('aria-hidden') == "false"){ // Make sure we're not calling setContent on null

                var post_content =  jQuery('#content-tinymce').val();
            } else{
                 var post_content = activeEditor.getContent();
            }

        } else{
            var post_content = jQuery('.helpie-article-editor .content-area .editor-content').html();
        }

        console.log('post_content: ' + post_content);

        var category_id = jQuery('#helpdesk_category-input').val();

        var post_state = 'edit-article';

        if (jQuery('.helpie-article-editor').hasClass('add-article')) {
            post_state = 'add-article';
        }

        var tags = addTermField.getCreatedTerms();
        var tag_stringify = tags.join(',');

        var livePostProps = {
            'post_id': post_id,
            'post_title': post_title,
            'post_content': post_content,
            'tags': tag_stringify,
            'category_id': category_id,
            'post_state': post_state,
        };

        return livePostProps;
    },

    publishArticle: function() {
        var thisModule = this;
        var livePostProps = thisModule.getLivePostData();

        var data = {
            'action': 'helpie_publish',
            'nonce': thisModule.nonce,
            'action-type': 'publish',
        };

        for (prop in livePostProps) {
            data[prop] = livePostProps[prop];
        }

        jQuery.post(my_ajax_object.ajax_url, data, function(response) {
            var post_id = response;
            thisModule.goToEditMode(post_id, livePostProps);
        });
    },

    goToEditMode: function(post_id, livePostProps){
        var current_url = window.location.href;

        if (livePostProps['post_state'] == 'add-article') {
            current_url = helpieUtils.removeParam('editor_mode', current_url);
            current_url += 'post_id=' + post_id;
        }

        setTimeout(function() {
            window.location.assign(current_url);
        }, 500);
    },

    setDiffMode: function() {
        jQuery('.helpie-article-editor').addClass('diff-mode');

        // jQuery('.article-publish.buttons .button.positive').html('Approve');

        jQuery('.article-publish.buttons .edit-post').show();
        jQuery('.article-publish.buttons .show-diff').hide();
        jQuery('.article-publish.buttons .save-post').hide();
    },

    setEditMode: function() {
        jQuery('.helpie-article-editor').removeClass('diff-mode');

        // jQuery('.article-publish.buttons .button.positive').html('Publish');

        jQuery('.article-publish.buttons .edit-post').hide();
        jQuery('.article-publish.buttons .show-diff').show();
        jQuery('.article-publish.buttons .save-post').show();
    },

    setCurrentRevision: function(element) {
        var thisModule = this;

        jQuery('.revisions .menu .item').removeClass('active');
        jQuery(element).addClass('active');

        var post_id = jQuery(element).data('post-id');
        var revision_id = jQuery(element).data('revision-id');
        var previous_revision_id = jQuery(element).data('previous-revision-id');

        // Set revision-id in editor
        jQuery('.helpie-article-editor').data("revision-id", revision_id);


        thisModule.getRevision(post_id, revision_id, previous_revision_id);
    },


    getRevision: function(post_id, revision_id, previous_revision_id) {
        var thisModule = this;
        var nonce = helpieKBFrontEndNonce;

        var data = {
            'action': 'helpie_get_revision',
            'nonce': nonce,
            'post_id': post_id,
            'revision_id': revision_id,
            'previous_revision_id': previous_revision_id,
        };

        jQuery.post(my_ajax_object.ajax_url, data, function(response) {
            var ajaxResponse = JSON.parse(response);
            console.log('getRevision: ... ');
            jQuery('.helpie-article-editor .content-area .title').html(ajaxResponse['title']);

            // For inline
            jQuery('.helpie-article-editor .content-area .editor-content').html(ajaxResponse['content']);

            // For wpeditor
            tinymce.get('content-tinymce').setContent(ajaxResponse['content']);

            var previous_html = '';

            if (ajaxResponse['diff_array']) {

                if (ajaxResponse['diff_array'][0]) {
                    previous_html += ajaxResponse['diff_array'][0]['diff'];
                }
                if (ajaxResponse['diff_array'][1]) {
                    previous_html += ajaxResponse['diff_array'][1]['diff'];
                }
            }

            jQuery('.helpie-article-editor .revision-diff-area .table-area').html(previous_html);


        });
    },

};

module.exports = Editor;
